<template>
    <b-card class="sa-card sa-card-scroll" header="" header-tag="header" footer-tag="footer" title="">
        <b-row>
            <b-col cols="12">
                <b-card class="sa-card sa-card-border" header="Struttura - Presidio" header-tag="header" footer-tag="footer" title="">
                    <!-- Sezione Informazioni Base -->
                    <b-row class="mb-3">
                        <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Codice Azienda:</label>
                            <span>{{ jsonData.codiceAzienda || "-" }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Tipo:</label>
                            <span>{{ jsonData.descrizioneTipoArticolo || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Codice AIC:</label>
                            <span>{{ jsonData.codiceAic || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Nome:</label>
                            <span>{{ jsonData.nomeArticolo || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Codice:</label>
                            <span>{{ jsonData.codiceArticolo || "-" }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Codice Barre:</label>
                            <span>{{ jsonData.codiceBarre || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Descrizione:</label>
                            <div class="sa-view-textarea">
                                {{ jsonData.descrizioneArticolo || "-" }}
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Sezione Classificazione -->
                    <b-row class="mb-3">
                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Unità di Misura:</label>
                            <span>{{ jsonData.um || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Categoria:</label>
                            <span>{{ jsonData.categoria || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Marca:</label>
                            <span>{{ jsonData.marca || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Multiplo:</label>
                            <span>{{ jsonData.descrizioneMultiplo || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Imballo:</label>
                            <span>{{ jsonData.descrizioneImballo || "-" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">I.V.A.:</label>
                            <span>{{ jsonData.descrizioneIva || "-" }}</span>
                        </b-col>
                    </b-row>

                    <!-- Sezione Gestione e Prezzi -->
                    <b-row class="mb-3">
                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Lotti e Scadenze:</label>
                            <span>{{ gestioneLottiScadenzeText }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Matricole:</label>
                            <span>{{ gestioneMatricoleText }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Ultimo Prezzo Acq.:</label>
                            <span>{{ "€ " + formatFloat(jsonData.ultimoPrezzoAcquisto, 2) }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Prezzo Medio Acq.:</label>
                            <span>{{ "€ " + formatFloat(jsonData.prezzoMedioAcquisto, 2) }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Sconto:</label>
                            <span>{{ formatFloat(jsonData.scontoArticolo, 2) + "%" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Sottoscorta:</label>
                            <span>{{ jsonData.sottoscortaArticolo || "-" }}</span>
                        </b-col>
                    </b-row>

                    <!-- Sezione Dati Fisici -->
                    <b-row class="mb-3">
                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Prezzo Acq. Standard:</label>
                            <span>{{ "€ " + formatFloat(jsonData.prezzoAcquistoStandard, 2) }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Colli:</label>
                            <span>{{ jsonData.colliArticolo || "-" }}</span>
                        </b-col>

                        <!-- da inserire KG -->
                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Peso:</label>
                            <span>{{ formatFloat(jsonData.pesoArticolo, 2) + "kg" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Lunghezza:</label>
                            <span>{{ formatFloat(jsonData.lunghezzaArticolo, 2) + "cm" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Altezza:</label>
                            <span>{{ formatFloat(jsonData.altezzaArticolo, 2) + "cm" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="6" md="2" lg="2" xl="2">
                            <label class="sa-label-data">Larghezza:</label>
                            <span>{{ formatFloat(jsonData.larghezzaArticolo, 2) + "cm" }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Note:</label>
                            <div class="sa-view-textarea">
                                {{ jsonData.noteArticolo || "-" }}
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <modal-error ref="cmpModalError" />
    </b-card>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
    name: "MagazzinoArticoliAnagraficaEditComponent",
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            id: "-1",
            pathResourceMagazzinoArticolo: "/magazzinoarticoli",
            jsonData: {
                id: null,
                codiceTipoArticolo: null,
                codiceArticolo: null,
                codiceBarre: null,
                nomeArticolo: null,
                descrizioneArticolo: null,
                codiceAzienda: null,
                um: null,
                categoria: null,
                marca: null,
                descrizioneMultiplo: null,
                descrizioneImballo: null,
                codiceIva: null,
                gestioneLottiScadenze: null,
                gestioneMatricole: null,
                ultimoPrezzoAcquisto: null,
                prezzoMedioAcquisto: null,
                scontoArticolo: null,
                sottoscortaArticolo: null,
                prezzoAcquistoStandard: null,
                colliArticolo: null,
                pesoArticolo: null,
                lunghezzaArticolo: null,
                altezzaArticolo: null,
                larghezzaArticolo: null,
                noteArticolo: null,
                giacenze: null,
                codiceAic: null,
            },
        };
    },
    computed: {
        gestioneLottiScadenzeText() {
            let me = this;
            if (me.jsonData.gestioneLottiScadenze === null) return "-";
            return me.jsonData.gestioneLottiScadenze ? "Sì" : "No";
        },

        gestioneMatricoleText() {
            let me = this;
            if (me.jsonData.gestioneMatricole === null) return "-";
            return me.jsonData.gestioneMatricole ? "Sì" : "No";
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;

        if (me.id != -1) {
            console.log("Entro nel if del mounted per visualizzazione");
            console.log("ID: ", me.id);
            me.loadDataArticoloMagazzino(me.id);
        }
    },
    beforeDestroy() {
        let me = this;
        me.controlEmit = false;
    },
    watch: {
        "jsonData.codiceTipoArticolo"(newValue) {
            let me = this;
            let isFarmaco = newValue === "FRM"; //Controllo booleano
            me.$emit("tipoArticolo", isFarmaco);
        },
    },
    methods: {
        loadDataArticoloMagazzino(id) {
            let me = this;
            console.log("Questo è id: ", id);

            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResourceMagazzinoArticolo + "/" + id, null, me.loadDataArticoloMagazzinoSuccess, me.loadDataArticoloMagazzinoError);
        },

        loadDataArticoloMagazzinoSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.jsonData = response.data.data;
            me.$emit("updateJsonData", me.jsonData);
        },

        loadDataArticoloMagazzinoError(response) {
            let me = this;
            me.$emit("afterLoadData");
            console.log(response);
            me.$refs.cmpModalError.show("Errore durante il caricamento dei dati dell'articolo");
        },
    },
};
</script>

<style></style>
